import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import WebsiteStoresProvider from './WebsiteStoresProvider'

@inject('websites')
@observer
class WebsiteWrapper extends Component {
  componentWillMount() {
    this.props.websites.load(this.props.params.website_id)
  }


  componentWillUnmount() {
    this.props.websites.setCurrent(null)
  }

  render() {
    if (!this.props.websites.loaded) {
      return (
        <div className="loading">Loading...</div>
      )
    }

    return (
      <WebsiteStoresProvider>
        {this.props.children}
      </WebsiteStoresProvider>
    )
  }
}

export default WebsiteWrapper



// WEBPACK FOOTER //
// client/components/WebsiteWrapper.js